import { createFileRoute } from "@tanstack/react-router";
import { StationNotFound } from "@/components/StationNotFound";
import { StationPlayer } from "@/components/StationPlayer";
import { queryKeys } from "@/hooks/useApiQuery";
import { apiClient } from "@/lib/api-client";

export const Route = createFileRoute("/_layout/station/$stationId")({
	component: StationView,
	loader: async ({ context, params }) => {
		try {
			const station = await context.queryClient.ensureQueryData({
				queryKey: queryKeys.detail(params.stationId),
				queryFn: () => apiClient.stations.get(params.stationId),
				staleTime: 1000,
			});
			return { station };
		} catch (_error) {
			// Return null if station not found
			return { station: null };
		}
	},
	head: ({ params, loaderData }) => {
		const station = loaderData?.station;
		const stationName = station?.name || params.stationId;
		const description =
			station?.description ||
			"Live on Macrowave - Share and listen to music with your friends.";

		return {
			meta: [
				{
					property: "og:title",
					content: `${stationName} - Macrowave`,
				},
				{
					property: "og:description",
					content: description,
				},
				{
					property: "og:type",
					content: "website",
				},
				{
					name: "twitter:card",
					content: "summary",
				},
				{
					name: "twitter:title",
					content: `${stationName} - Macrowave`,
				},
				{
					name: "twitter:description",
					content: description,
				},
			],
		};
	},
});

function StationView() {
	const { stationId } = Route.useParams();
	const { station } = Route.useLoaderData();

	if (!station) {
		return <StationNotFound stationId={stationId} />;
	}

	return <StationPlayer station={station} />;
}
